module.exports = __webpack_public_path__ + "img/face-scan.dba18c87.jpg";